import React from 'react';

export function Checkbox({ label, checked, onChange, disabled, id, className = '' }) {
  const inputId = id || (label ? `ds-cb-${String(label).slice(0, 20)}` : undefined);
  return (
    <label className={`ds-checkbox ${className}`.trim()}>
      <input
        type="checkbox"
        id={inputId}
        className="ds-checkbox__input"
        checked={checked}
        onChange={onChange}
        disabled={disabled}
      />
      <span className="ds-checkbox__box" aria-hidden />
      {label ? <span className="ds-checkbox__label">{label}</span> : null}
    </label>
  );
}

export function Switch({ label, checked, onChange, disabled, className = '' }) {
  return (
    <label className={`ds-switch ${className}`.trim()}>
      <input
        type="checkbox"
        className="ds-switch__input"
        role="switch"
        checked={checked}
        onChange={onChange}
        disabled={disabled}
      />
      <span className="ds-switch__track" aria-hidden />
      {label ? <span className="ds-switch__label">{label}</span> : null}
    </label>
  );
}

export default Checkbox;
